import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guard/auth.guard';
const routes: Routes = [
  {
    path: '',
    redirectTo: 'job-posting',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'job-posting',
    loadChildren: () => import('./pages/job-posting/job-posting.module').then( m => m.JobPostingPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'enquiry',
    loadChildren: () => import('./pages/enquiry/enquiry.module').then( m => m.EnquiryPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'job-posting-inquiry/:id',
    loadChildren: () => import('./pages/job-posting-inquiry/job-posting-inquiry.module').then( m => m.JobPostingInquiryPageModule),
    canActivate: [AuthGuard]
  },

  {
    path: 'job-posting-detail/:id',
    loadChildren: () => import('./pages/job-posting-detail/job-posting-detail.module').then( m => m.JobPostingDetailPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'enquiry-detail/:id',
    loadChildren: () => import('./pages/enquiry-detail/enquiry-detail.module').then( m => m.EnquiryDetailPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'application',
    loadChildren: () => import('./pages/application/application.module').then( m => m.ApplicationPageModule)
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
